module.exports = __webpack_public_path__ + "app/bento-components/blog-river/media/twitter.svg?571458853d2d0b93f751099b8a197302";